export const LOGOUT_LINK_TEXT = 'Logout';
